import {PayloadBuilder, PayloadBuildersRegistry} from 'ui/adapters/Analytics';
import {BuildersRegistry} from './registry';

interface Dependencies {
  registry?: PayloadBuildersRegistry;
}

export function payloadBuilderFor(
  event: AnalyticsEventName,
  di: Dependencies = {}
): PayloadBuilder {
  const {registry = BuildersRegistry} = di;
  const builder = registry[event];
  return builder;
}
